export const enter_area = class {
  constructor(el, blueprint, view) {
    this.create_main_el($(el));
    this.blueprint = blueprint;
    this.generate_enter_blocks(blueprint);
    if (view) this.toggle_view(true);
  }
  toggle_view(target_val) {
    Object.values(this.blocks).forEach(enter_block => enter_block.toggle_view(target_val));
  }
  create_main_el(outer_el) {
    this.el = $('<div class="enter_area"></div>');
    outer_el.empty().append(this.el);
  }
  generate_enter_blocks(blueprint) {
    this.blocks = {};
    blueprint.forEach(block_data => generate_enter_block(block_data, this));
  }
  generate_enter_block_outer(data) {
    let outer = new enter_block_outer(data, this);
    return outer;
  }
  append_enter_block(block_data, param1, param2) {
    let new_enter_block = generate_enter_block(block_data, this);
    if (param1 == undefined && param2 == undefined) return;
    let index;
    if (typeof param1 == 'number') index = param1;
    else if (typeof param2 == 'number') index = param2;
    let outer_el = this.el;
    if (typeof param1 == 'string' && this.blocks[param1] && this.blocks[param1] instanceof enter_block_outer) {
      outer_el = this.blocks[param1].el;
    }
    new_enter_block.set_outer_el(outer_el, index);
  }
  valid() {
    let error = false;
    for (let key in this.blocks) {
      error = !this.blocks[key].valid() || error;
    }
    error = !this.trigger_check() || error;
    return !error;
  }
  get_form_data() {
    let form_data = {};
    for (let key in this.blocks) {
      let block = this.blocks[key];
      let value = block.get_value();
      if (value != null) {
        form_data[key] = value;
      }
    }
    return form_data;
  }
  set_form_data(new_form_data) {
    for (let key in new_form_data) {
      this.set_enter_block_data(key, new_form_data[key]);
    }
  }
  set_enter_block_data(key, value) {
    let block = this.blocks[key];
    if (block) block.set_value(value);
  }
  set_enter_block_options(key, options, values) {
    if (this.blocks[key]) {
      this.blocks[key].set_options(options, values);
    }
  }
  set_enter_blocks_onclick_by_custom_type(custom_type, click_function) {
    Object.values(this.blocks)
      .filter(block => block.custom_type == custom_type)
      .forEach(block => block.set_onclick(click_function));
  }
  get_outer_el_by_key(key) {
    if (this.blocks[key] && this.blocks[key] instanceof enter_block_outer) {
      return this.blocks[key].el;
    }
    return null;
  }
  trigger_check() {
    if (typeof this.check_function != 'function') return true;
    let form_data = this.get_form_data();
    let error_msgs = this.check_function(form_data);
    if(error_msgs) {
      for(let key in error_msgs) {
        this.blocks[key].el.attr('error', error_msgs[key] || null);
      }
    }
    return !error_msgs;
  }
  trigger_change(block) {
    if (typeof this.change_function != 'function') return;
    let key = Object.keys(this.blocks).find(key => this.blocks[key] == block);
    let form_data = this.get_form_data();
    let new_form_data = this.change_function(form_data, key);
    if (new_form_data) this.set_form_data(new_form_data);
  }
}

class enter_block {
  constructor(data, parent_area, enter_block_el) {
    if (!data) return;
    this.set_parent_area(parent_area, data);
    this.el = enter_block_el || this.generate_outer_el(data, parent_area.el);
    this.data_set(data);
    this.generate_el(data);
    this.set_event_function(data);
    this.value = null;
  }
  getable() { return false; }
  set_parent_area(parent_area, data) {
    this.parent_area = parent_area;
    if (this.getable() && data.key) this.parent_area.blocks[data.key] = this;
  }
  toggle_view(target_val) { this.el.toggleClass('view', target_val); }
  /* -------- 生成 -------- */
  data_set() { }
  generate_outer_el(data, parent_area_el) {
    let class_list = ['enter_block'];
    if (data.div) class_list.push('div_' + data.div);
    else switch (data.type) {
      case 'br': class_list.push('div_line'); break;
      case 'span': class_list.push('div_auto'); break;
      default: class_list.push('div_1'); break;
    }
    if (Array.isArray(data.class_name)) class_list = class_list.concat(data.class_name);
    else if (typeof data.class_name == 'string') class_list.push(data.class_name);
    if (data.type == 'onoff' || data.type == 'input_onoff') class_list.push('flex_row');
    let target_css_var = {};
    if (data.css_var) {
      for (let name in data.css_var) {
        target_css_var['--' + name] = data.css_var[name];
      }
    }
    return $('<div>', {
      'data-key': data.key || null,
      'data-type': data.type || null,
    })
      .addClass(class_list)
      .css(target_css_var)
      .appendTo(parent_area_el);
  }
  generate_el() { }
  set_outer_el(outer_el, index) {
    let after_enter_block_el;
    if (typeof index == 'number') {
      index = Math.floor(index);
      after_enter_block_el = outer_el.children().eq(index);
    }
    if (after_enter_block_el) {
      this.el.insertBefore(after_enter_block_el);
    }
    else {
      this.el.appendTo(outer_el);
    }
  }
  /* -------- 設定選項 -------- */
  set_options() { }
  /* -------- 值 -------- */
  get_value() {
    return this.value;
  }
  set_value(new_value) {
    this.value = new_value;
    this.valid();
  }
  /* -------- function -------- */
  valid() {
    let error_msg = this.trigger_check();
    this.el.attr('error', error_msg || null);
    return !error_msg;
  }
  set_event_function(data) {
    if (!this.getable()) return;
    if (data.check) this.check_function = data.check;
    if (data.change) this.change_function = data.change;
    if (data.input) this.input_function = data.input;
    if (data.click) this.click_function = data.click;
  }
  trigger_check() {
    if (!this.parent_area) return;
    if (typeof this.check_function != 'function') return;
    let form_data = this.parent_area.get_form_data();
    return this.check_function(this.get_value(), form_data);
  }
  trigger_change() {
    if (!this.parent_area) return;
    if (typeof this.change_function == 'function') {
      let form_data = this.parent_area.get_form_data();
      let new_form_data = this.change_function(this.get_value(), form_data);
      if (new_form_data) this.parent_area.set_form_data(new_form_data);
    }
    this.parent_area.trigger_change(this);
  }
  trigger_input() {
    if (!this.parent_area) return;
    if (typeof this.input_function != 'function') return;
    let form_data = this.parent_area.get_form_data();
    let new_form_data = this.input_function(this.get_value(), form_data);
    if (new_form_data) this.parent_area.set_form_data(new_form_data);
  }
  trigger_click() {
    if (!this.parent_area) return;
    if (typeof this.click_function != 'function') return;
    let form_data = this.parent_area.get_form_data();
    let new_form_data = this.click_function(this, form_data);
    if (new_form_data) this.parent_area.set_form_data(new_form_data);
  }
}

/* ================ outer ================ */
class enter_block_outer extends enter_block {
  constructor(data, parent_area) {
    super(data, parent_area);
    this._generate_blocks(parent_area, data.blocks);
  }
  _generate_blocks(parent_area, blocks_data) {
    if (blocks_data) blocks_data.forEach(block_data => {
      generate_enter_block(block_data, parent_area).set_outer_el(this.el);
    });
  }
  set_parent_area(parent_area, data) {
    this.parent_area = parent_area;
    if (data.key) this.parent_area.blocks[data.key] = this;
  }
}

/* ================ section_title ================ */
class enter_block_section_title extends enter_block {
  constructor(data, parent_area) {
    super(data, parent_area);
  }
  generate_el(data) {
    $('<h6>').text(data.text).appendTo(this.el);
    if (data.sub_text) $('<span>').text(data.sub_text).appendTo(this.el);
  }
}

/* ================ hr ================ */
class enter_block_hr extends enter_block {
  constructor(data, parent_area) {
    super(data, parent_area);
  }
  generate_el(data) {
    $('<hr>').appendTo(this.el);
  }
}

/* ================ span ================ */
class enter_block_span extends enter_block {
  constructor(data, parent_area) {
    super(data, parent_area);
  }
  generate_el(data) {
    let span = $('<span>').text(new String(data.text).replace(/\n/g, '<br>'));
    span.html(span.html().replace(/&lt;br&gt;/g, '<br>')).appendTo(this.el);
  }
}

/* ================ label ================ */
class enter_block_label extends enter_block {
  constructor(data, parent_area) {
    super(data, parent_area);
  }
  generate_el(data) {
    $('<label>', { 'for': data.for || null }).text(data.text).appendTo(this.el);
  }
}

/* ================ output ================ */
class enter_block_output extends enter_block {
  constructor(data, parent_area, enter_block_el) {
    super(data, parent_area, enter_block_el);
    this.set_value(data.default);
  }
  set_parent_area(parent_area, data) {
    this.parent_area = parent_area;
    if (data.key) this.parent_area.blocks[data.key] = this;
  }
  generate_el(data) {
    if (data.label) {
      $('<label>').text(data.label).appendTo(this.el);
    }
    this.output_el = $('<output>');
    let el = enter_block_icon_outer(this.output_el, data.icon);
    square_style(el, data).appendTo(this.el);
    if (data.tail_label) {
      $('<label>').text(data.tail_label).appendTo(this.el);
    }
  }
  set_value(new_value) {
    this.output_el.val(new_value);
    this.value = new_value || '';
  }
}

/* ================ input ================ */
class enter_block_input extends enter_block {
  constructor(data, parent_area, enter_block_el) {
    super(data, parent_area, enter_block_el);
    this.set_default_value(data.default);
  }
  toggle_view(target_val) {
    super.toggle_view(target_val);
    this.input_el.attr('disabled', target_val || this.disabled || null);
  }
  getable() { return true; }
  data_set(data) {
    if (data.max_length) this.max_length = data.max_length;
    if (data.required) this.required = true;
    if (data.disabled) this.disabled = true;
  }
  generate_el(data, id_and_for) {
    if (!id_and_for) id_and_for = data.key;
    if (data.label) this._generate_label_el(data, id_and_for);
    this._generate_input_el(data, id_and_for);
    if (data.tail_label) this._generate_tail_label_el(data, id_and_for);
  }
  _generate_input_el(data, id_and_for) {
    this.input_el = $('<input>', {
      id: id_and_for,
      disabled: this.disabled || null,
      placeholder: data.placeholder || null,
    })
      .on('input', () => this.input())
      .on('change', () => this.change());
    let el = enter_block_icon_outer(this.input_el, data.icon);
    square_style(el, data).appendTo(this.el);
  }
  _generate_label_el(data, id_and_for) {
    let label_el = $('<label>', { for: id_and_for })
      .toggleClass('required', data.required || false)
      .text(data.label)
      .appendTo(this.el);
    if (data.max_length) {
      this.remind_el = $('<span>').text('(0/' + data.max_length + ')')
        .appendTo(label_el);
    }
  }
  _generate_tail_label_el(data, id_and_for) {
    $('<label>', { for: id_and_for })
      .text(data.tail_label)
      .appendTo(this.el);
  }
  set_default_value(default_value) {
    this.input_el.val(default_value);
    this._set_value(default_value);
  }
  _set_value(value) {
    this.value = value;
    if (this.max_length) this._max_length_remind();
  }
  set_value(new_value) {
    this.input_el.val(new_value);
    super.set_value(new_value);
    if (this.max_length) this._max_length_remind();
  }
  valid() {
    if (!super.valid()) return false;
    if (!this._max_length_check()) return false;
    if (!this._required_check()) return false;
    return true;
  }
  input() {
    this._set_value(this.input_el.val());
    this.trigger_input();
  }
  change() {
    this._set_value(this.input_el.val());
    this.trigger_change();
    this.valid();
  }
  _max_length_remind() {
    if(!this.remind_el) return;
    this.remind_el
      .text(`(${(this.value || '').length}/${this.max_length})`)
      .toggleClass('error', (this.value || '').length > this.max_length);
  }
  _max_length_check() {
    if (!this.max_length || (this.value || '').length <= this.max_length) return true;
    this.el.attr('error', '輸入長度超出限制 (' + this.max_length + ')');
    return false;
  }
  _required_check() {
    if (!this.required || this.value) return true;
    this.el.attr('error', '必填');
    return false;
  }
}

/* ================ number ================ */
class enter_block_number extends enter_block_input {
  constructor(data, parent_area, enter_block_el) {
    super(data, parent_area, enter_block_el);
    this.input_el.attr('type', 'number');
  }
  data_set(data) {
    if (Number.isInteger(data.decimal_place)) this.decimal_place = data.decimal_place;
    if (typeof data.min == 'number') this.min = Math.floor(data.min);
    if (typeof data.max == 'number') this.max = Math.floor(data.max);
    if (data.required) this.required = true;
    if (data.disabled) this.disabled = true;
  }
  set_default_value(default_value) {
    if (typeof default_value != 'number') default_value = null;
    this.input_el.val(default_value);
    this.value = default_value;
  }
  _limit_check(value) {
    value = +value || 0;
    if (value < this.min) value = this.min;
    if (value > this.max) value = this.max;
    if (typeof this.decimal_place == 'number') {
      value = +(Math.round(value + "e" + this.decimal_place) + "e" + (this.decimal_place * -1));
    }
    return value;
  }
  input() {
    this.value = this._limit_check(this.input_el.val());
    this.trigger_input();
  }
  change() {
    this.value = this._limit_check(this.input_el.val());
    this.input_el.val(this.value)
    this.trigger_change();
    this.valid();
  }
  get_value() {
    if (this.value == null) return null;
    return +this.value;
  }
  set_value(new_value) {
    if (typeof new_value != 'number') new_value = 0;
    this.input_el.val(+new_value || 0);
    super.set_value(+new_value || 0);
  }
  _required_check() {
    if (!this.required || this.value != null) return true;
    this.el.attr('error', '必填');
    return false;
  }
}

/* ================ password ================ */
class enter_block_password extends enter_block_input {
  constructor(data, parent_area, enter_block_el) {
    super(data, parent_area, enter_block_el);
    this.input_el.attr('type', 'password');
  }
}

/* ================ select ================ */
class enter_block_select extends enter_block {
  constructor(data, parent_area) {
    super(data, parent_area);
    this.set_default_value(data.default);
  }
  toggle_view(target_val) {
    super.toggle_view(target_val);
    this.select_el.attr('disabled', target_val || this.disabled || null);
  }
  getable() { return true; }
  data_set(data) {
    this.values = data.values || data.options || [];
    if (data.placeholder) {
      if (data.required) this.required = true;
      this.placeholder = data.placeholder;
    }
    if (data.disabled) this.disabled = true;
  }
  generate_el(data) {
    if (data.label) this._generate_label_el(data);
    this._generate_select_el(data);
    this._generate_placeholder_el();
  }
  _generate_label_el(data) {
    $('<label>', { for: data.key })
      .text(data.label)
      .toggleClass('required', this.required || false)
      .appendTo(this.el);
  }
  _generate_select_el(data) {
    this.select_el = $('<select>', {
      id: data.key,
      disabled: this.disabled,
    })
      .on('change', () => this.change())
      .appendTo(this.el);
    this._generate_options_el(data.options);
    let el = enter_block_icon_outer(this.select_el, data.icon);
    square_style(el, data).appendTo(this.el);
  }
  _generate_options_el(options) {
    this.select_el.empty();
    if (options) options.forEach((option, index) => {
      $('<option>', {
        value: index,
      }).text(option).appendTo(this.select_el);
    });
  }
  _generate_placeholder_el() {
    if (!this.placeholder) return;
    $('<option>', {
      value: "null",
      hidden: true,
      selected: true,
    })
      .text(this.placeholder)
      .prependTo(this.select_el);
    this.select_el.addClass('is_null');
  }
  set_options(options, values) {
    this.values = values || options || [];
    this._generate_options_el(options);
    this._generate_placeholder_el();
    if (!this.placeholder) {
      this.value = this.values[0];
      this.select_el.removeClass('is_null');
    }
  }
  _set_el_val(value) {
    let index = this.values.indexOf(value);
    if (index == -1) {
      this.select_el.addClass('is_null');
      return null;
    }
    this.select_el.val(index).removeClass('is_null');
    return value;
  }
  _get_el_val() {
    let index = this.select_el.val();
    if (index == null || index == 'null') return null;
    this.select_el.removeClass('is_null');
    return this.values[index];
  }
  set_default_value(default_value) {
    if (!default_value && !this.placeholder) default_value = this.values[0];
    default_value = this._set_el_val(default_value);
    this.value = default_value;
  }
  get_value() {
    if (this.value == "null") return null;
    return this.value;
  }
  set_value(new_value) {
    new_value = this._set_el_val(new_value);
    super.set_value(new_value);
  }
  valid() {
    if (!super.valid()) return false;
    if (!this._required_check()) return false;
    return true;
  }
  change() {
    this.value = this._get_el_val();
    this.trigger_change();
    this.valid();
  }
  _required_check() {
    if (!this.required || this.value) return true;
    this.el.attr('error', '必填');
    return false;
  }
}

/* ================ textarea ================ */
class enter_block_textarea extends enter_block_input {
  constructor(data, parent_area) {
    super(data, parent_area);
  }
  generate_el(data) {
    if (data.label) this._generate_label_el(data);
    this._generate_input_el(data);
    if (data.max_length) this._generate_max_length_el(data);
  }
  _generate_label_el(data) {
    $('<label>', { for: data.key })
      .toggleClass('required', data.required || false)
      .text(data.label)
      .appendTo(this.el);
  }
  _generate_input_el(data, id_and_for) {
    this.input_el = $('<textarea>', {
      id: data.key,
      disabled: data.disabled || null,
      placeholder: data.placeholder || null,
    })
      .on('input', () => this.input())
      .on('change', () => this.change())
      .appendTo(this.el);
  }
  _generate_max_length_el(data) {
    this.remind_el = $('<label class="max_length">', { for: data.key })
      .text('(0/' + data.max_length + ')')
      .appendTo(this.el);
  }
}

/* ================ onoff ================ */
class enter_block_onoff extends enter_block {
  constructor(data, parent_area) {
    super(data, parent_area);
    this.set_default_value(data.default);
  }
  toggle_view(target_val) {
    super.toggle_view(target_val);
    this.checkbox_el.attr('disabled', target_val || this.disabled || null);
  }
  getable() { return true; }
  data_set(data) {
    if (data.disabled) this.disabled = true;
  }
  generate_el(data) {
    this.checkbox_el = $('<input>', {
      type: 'checkbox',
      disabled: this.disabled,
      id: data.key,
    })
      .on('change', () => this.change())
      .appendTo(this.el);
    if (data.label) $('<label>', { 'for': data.key }).text(data.label).appendTo(this.el);
  }
  set_default_value(default_value) {
    this.checkbox_el.prop('checked', !!default_value);
    this.value = default_value ? 1 : 0;
  }
  set_value(new_value) {
    this.checkbox_el.prop('checked', !!new_value);
    super.set_value(new_value ? 1 : 0);
  }
  change() {
    this.value = this.checkbox_el.is(':checked') ? 1 : 0;
    this.trigger_change();
    this.valid();
  }
}

/* ================ radio ================ */
class enter_block_radio extends enter_block {
  constructor(data, parent_area) {
    super(data, parent_area);
    this.set_default_value(data.default);
  }
  toggle_view(target_val) {
    super.toggle_view(target_val);
    this.radio_list_el.find('input').attr('disabled', target_val || this.disabled || null);
  }
  getable() { return true; }
  data_set(data) {
    this.values = data.values || data.options || [];
    if (data.required) this.required = true;
    if (data.disabled) this.disabled = true;
  }
  generate_el(data) {
    if (data.label) $('<label>').text(data.label).toggleClass('required', data.required || false).appendTo(this.el);
    this.radio_list_el = $('<div class="radio_list">').appendTo(this.el);
    options_list_style(this.radio_list_el, data.list_style);
    this._generate_options_el(data.options);
  }
  _generate_options_el(options) {
    this.radio_list_el.empty();
    let key = this.el.attr('data-key');
    if (options) options.forEach((option, index) => {
      let radio_el = $('<div class="radio">').appendTo(this.radio_list_el);
      $('<input>', {
        type: 'radio',
        id: key + "_" + option,
        name: key,
        disabled: this.disabled,
        value: index,
      })
        .on('change', () => this.change())
        .appendTo(radio_el);
      $('<label>', { for: key + "_" + option })
        .text(option)
        .appendTo(radio_el);
      radio_can_be_canceled(radio_el[0]);
    });
  }
  set_options(options, values) {
    this.values = values || options || [];
    this._generate_options_el(options);
  }
  _set_el_val(value) {
    let index = this.values.indexOf(value);
    if (index == -1) {
      this.radio_list_el.find('input').prop('checked', false);
      return null;
    }
    this.radio_list_el.find('[value="' + index + '"]').prop('checked', true);
    return this.values[index];
  }
  _get_el_val() {
    let checked_el = this.radio_list_el.find(':checked');
    if(!checked_el.length) return null;
    let index = checked_el.attr('value');
    return this.values[index];
  }
  set_default_value(default_value) {
    default_value = this._set_el_val(default_value);
    this.value = default_value || null;
  }
  set_value(new_value) {
    new_value = this._set_el_val(new_value);
    super.set_value(new_value);
  }
  valid() {
    if (!super.valid()) return false;
    if (!this._required_check()) return false;
    return true;
  }
  change() {
    this.value = this._get_el_val();
    this.trigger_change();
    this.valid();
  }
  _required_check() {
    if (!this.required || this.value != null) return true;
    this.el.attr('error', '必填');
    return false;
  }
}

/* ================ checkbox ================ */
class enter_block_checkbox extends enter_block {
  constructor(data, parent_area) {
    super(data, parent_area);
    this.set_default_value(data.default);
  }
  toggle_view(target_val) {
    super.toggle_view(target_val);
    this.checkbox_list_el.find('input').attr('disabled', target_val || this.disabled || null);
  }
  getable() { return true; }
  data_set(data) {
    this.values = data.values || data.options || [];
    if (data.disabled) this.disabled = true;
    if (typeof data.limit == 'number') this.limit = Math.floor(data.limit);
    else {
      if (typeof data.min == 'number') this.min = Math.floor(data.min);
      if (typeof data.max == 'number') this.max = Math.floor(data.max);
    }
  }
  generate_el(data) {
    if (data.label) $('<label>').text(data.label).appendTo(this.el);
    this.checkbox_list_el = $('<div class="checkbox_list">').appendTo(this.el);
    options_list_style(this.checkbox_list_el, data.list_style);
    this._generate_options_el(data.options);
  }
  _generate_options_el(options) {
    this.checkbox_list_el.empty();
    let key = this.el.attr('data-key');
    if (options) options.forEach((option, index) => {
      let checkbox_el = $('<div class="checkbox">').appendTo(this.checkbox_list_el);
      $('<input>', {
        type: 'checkbox',
        id: key + "_" + option,
        disabled: this.disabled,
        value: index,
      })
        .on('change', () => this.change())
        .appendTo(checkbox_el);
      $('<label>', { for: key + "_" + option })
        .text(option)
        .appendTo(checkbox_el);
    });
  }
  set_options(options, values) {
    this.values = values || options || [];
    this._generate_options_el(options);
  }
  _set_el_val(values) {
    this.checkbox_list_el.find('input').prop('checked', false);
    if (!Array.isArray(values)) return [];
    return values.map(value => {
      let index = this.values.indexOf(value);
      if (index == -1) return;
      this.checkbox_list_el
        .find('[value="' + index + '"]')
        .prop('checked', true);
      return this.values[index];
    }).filter(val => val);
  }
  _get_el_val() {
    return [...this.checkbox_list_el.find(':checked')]
      .map(el => this.values[el.value]);
  }
  set_default_value(default_value) {
    default_value = this._set_el_val(default_value);
    this.value = default_value;
  }
  set_value(new_value) {
    new_value = this._set_el_val(new_value);
    super.set_value(new_value);
  }
  valid() {
    if (!super.valid()) return false;
    if (!this._checked_count_check()) return false;
    return true;
  }
  change() {
    this.value = this._get_el_val();
    this.trigger_change();
    this.el.attr('error', null);
  }
  _checked_count_check() {
    if (typeof this.limit == 'number' && this.value.length != this.limit) {
      this.el.attr('error', '需要選擇 ' + this.limit + ' 個選項');
      return false;
    }
    if (typeof this.min == 'number' && this.value.length < this.min) {
      this.el.attr('error', '至少選擇 ' + this.min + ' 個選項');
      return false;
    }
    if (typeof this.max == 'number' && this.value.length > this.max) {
      this.el.attr('error', '最多選擇 ' + this.max + ' 個選項');
      return false;
    }
    return true;
  }
  _required_check() {
    if (!this.required || this.value != null) return true;
    this.el.attr('error', '必填');
    return false;
  }
}

/* ================ input_onoff ================ */
class enter_block_input_onoff_checkbox extends enter_block_onoff {
  constructor(data, parent_area) {
    super(data, parent_area);
    this.text_input = new enter_block_input_onoff_text(data, parent_area, this);
  }
  data_set(data) {
    if (data.checked_required) this.required = true;
    if (data.disabled) this.disabled = true;
  }
  generate_el(data) {
    this.checkbox_el = $('<input>', {
      type: 'checkbox',
      disabled: this.disabled,
      id: data.key,
    })
      .on('change', () => this.change())
      .appendTo(this.el);
  }
  valid() {
    if (!super.valid()) return false;
    if (!this._text_input_check()) return false;
    return true;
  }
  change() {
    this.value = this.checkbox_el.is(':checked') ? 1 : 0;
    this.trigger_change();
    if (!this.value) this.text_input.set_value(null);
    this.el.attr('error', null);
  }
  _text_input_check() {
    let text_value = this.text_input.get_value();
    if (text_value && !this.value) {
      this.value = 1;
      this.checkbox_el.prop('checked', true);
    }
    if (this.required && this.value && !text_value) {
      this.el.attr('error', '勾選後必填');
      return false;
    }
    return true;
  }
}
class enter_block_input_onoff_text extends enter_block_input {
  constructor(data, parent_area, onoff) {
    super(data, parent_area, onoff.el);
    this.onoff = onoff;
  }
  toggle_view(target_val) {
    super.toggle_view(target_val);
    this.input_el.attr('disabled', target_val || this.disabled || null);
    if (!this.has_onoff_key) return this.onoff.toggle_view(target_val);
  }
  data_set(data) {
    if (data.key) this.has_onoff_key = true;
    if (data.disabled) this.disabled = true;
    if (data.max_length) this.max_length = data.max_length;
  }
  generate_el(data, id_and_for) {
    super.generate_el(data, data.input_key);
  }
  set_parent_area(parent_area, data) {
    this.parent_area = parent_area;
    if (data.input_key) this.parent_area.blocks[data.input_key] = this;
  }
  set_value(new_value) {
    this.input_el.val(new_value);
    super.set_value(new_value);
    if (this.max_length) this._max_length_remind();
    if (!this.has_onoff_key && new_value) {
      this.onoff.value = 1;
      this.onoff.checkbox_el.prop('checked', true);
    }
  }
  change() {
    this.value = this.input_el.val() || null;
    this.onoff.set_value(!!this.value);
    this._max_length_check();
  }
  valid() {
    if (!this._max_length_check()) return false;
    if (this.has_onoff_key) return this.onoff.valid();
    if (!this.onoff.value) return true;
    if (!this.value) {
      this.el.attr('error', '勾選後必填');
      return false;
    }
    return true;
  }
}

/* ================ radio_table ================ */
class enter_block_radio_table extends enter_block {
  constructor(data, parent_area) {
    super(data, parent_area);
    this.set_default_value(data.default);
  }
  toggle_view(target_val) {
    super.toggle_view(target_val);
    this.radio_list_el.forEach(radio_el => radio_el.find('input').attr('disabled', target_val || this.disabled || null));
  }
  getable() { return true; }
  data_set(data) {
    this.values = data.values || data.options || [];
    if (data.required) this.required = true;
    if (data.disabled) this.disabled = true;
  }
  generate_el(data) {
    let thead = this._generate_thead_el(data);
    let tbody = this._generate_tbody_el(data);
    $('<table class="radio_table"></table>')
      .append(thead).append(tbody).appendTo(this.el);
  }
  _generate_thead_el(data) {
    if (data.no_thead) return null;
    let tr = $('<tr>');
    tr.append('<th>' + (data.label || '提項') + '</th>');
    data.options.forEach(option => {
      tr.append('<th>' + option + '</th>');
    });
    return $('<thead></thead>').append(tr);
  }
  _generate_tbody_el(data) {
    let tbody = $('<tbody>');
    this.radio_list_el = data.items.map((item, item_index) => {
      if (typeof item == 'string') {
        return this._generate_item_el(data, tbody, item, item_index);
      }
      if (Array.isArray(item)) {
        this._generate_section_tr_el(data, tbody, item[0]);
      }
    }).filter(el => el);
    return tbody;
  }
  _generate_item_el(data, tbody, item, item_index) {
    let colspan = data.options.length + 1;
    tbody.append('<tr class="item_name"><td colspan="' + colspan + '">' + item + '</td></tr>');
    let tds = data.options.map((option, option_index) => {
      let input = $('<input>', {
        type: 'radio',
        disabled: this.disabled,
        name: data.key + '_' + item_index,
        value: option_index,
      })
        .on('change', () => this.change());
      radio_can_be_canceled(input[0]);
      return $('<td>').attr('data-name', option).append(input);
    });
    return $('<tr class="item_radio">').append('<td>' + item + '</td>').append(tds).appendTo(tbody);
  }
  _generate_section_tr_el(data, tbody, item) {
    let colspan = data.options.length + 1;
    tbody.append('<tr><td colspan="' + colspan + '">' + item + '</td></tr>');
  }
  get_value() {
    if (this.value) return [...this.value];
    return null;
  }
  set_default_value(default_value) {
    default_value = this._set_el_val(default_value);
    this.value = default_value;
  }
  _get_el_val() {
    return this.radio_list_el.map(el => {
      let option_index = el.find('input:checked').val();
      if (typeof option_index == "string") return this.values[option_index];
      return null;
    });
  }
  _set_el_val(values) {
    if (!Array.isArray(values)) return [];
    return this.radio_list_el.map((el, item_index) => {
      let option_index = this.values.indexOf(values[item_index]);
      if (option_index == -1) {
        el.find('input:checked').prop('checked', false);
        return null;
      }
      el.find('input[value="' + option_index + '"]').prop('checked', true);
      return values[item_index];
    });
  }
  valid() {
    if (!super.valid()) return false;
    if (!this._required_check()) return false;
    return true;
  }
  change() {
    this.value = this._get_el_val();
    this.trigger_change();
    this.el.attr('error', null);
    let checked_count = this.value.filter(val => val != null).length;
    let item_count = this.radio_list_el.length;
    if (checked_count == item_count) this.valid();
  }
  set_value(new_value) {
    new_value = this._set_el_val(new_value);
    super.set_value(new_value);
  }
  _required_check() {
    if (!this.required) return true;
    if (this.value.length != 0 && this.value.findIndex(v => v == null) == -1) return true;
    this.el.attr('error', '必填');
    return false;
  }
}

/* ================ select_table ================ */
class enter_block_select_table extends enter_block {
  constructor(data, parent_area) {
    super(data, parent_area);
    this.set_default_value(data.default);
  }
  toggle_view(target_val) {
    super.toggle_view(target_val);
    this.select_list_el.forEach(select_el => select_el.attr('disabled', target_val || this.disabled || null));
  }
  getable() { return true; }
  data_set(data) {
    this.values = data.values || data.options || [];
    if (data.required) this.required = true;
    if (data.disabled) this.disabled = true;
  }
  generate_el(data) {
    let thead = this._generate_thead_el(data);
    let tbody = this._generate_tbody_el(data);
    $('<table class="select_table"></table>')
      .append(thead).append(tbody).appendTo(this.el);
  }
  _generate_thead_el(data) {
    if (data.no_thead) return null;
    let tr = $('<tr>');
    tr.append('<th>' + (data.label || '項目') + '</th>');
    tr.append('<th>' + (data.select_name || '選項') + '</th>');
    return $('<thead></thead>').append(tr);
  }
  _generate_tbody_el(data) {
    let tbody = $('<tbody>');
    this.select_list_el = data.items.map((item, item_index) => {
      if (typeof item == 'string') {
        return this._generate_item_el(data, tbody, item, item_index);
      }
      if (Array.isArray(item)) {
        tbody.append('<tr><td colspan="2">' + item[0] + '</td></tr>');
      }
    }).filter(el => el);
    return tbody;
  }
  _generate_item_el(data, tbody, item, item_index) {
    let select_el = $('<select>', {
      name: data.key + '_' + item_index,
      disabled: this.disabled,
    })
      .on('change', () => this.change());
    if (data.options) data.options.forEach((option, option_index) => {
      $('<option>', {
        value: option_index,
      }).text(option).appendTo(select_el);
    });
    if (data.placeholder) {
      $('<option>', {
        value: "null",
        hidden: true,
        selected: true,
      })
        .text(data.placeholder)
        .prependTo(select_el);
      select_el.addClass('is_null');
    }
    let td = $('<td>').append(select_el);
    $('<tr class="item_select">').append('<td>' + item + '</td>').append(td).appendTo(tbody);
    return select_el;
  }
  get_value() {
    if (this.value) return [...this.value];
    return null;
  }
  set_default_value(default_value) {
    default_value = this._set_el_val(default_value);
    this.value = default_value;
  }
  _get_el_val() {
    return this.select_list_el.map(el => {
      let option_index = el.val();
      if (!option_index || option_index == 'null') return null;
      el.removeClass('is_null');
      return this.values[option_index];
    });
  }
  _set_el_val(values) {
    if (!Array.isArray(values)) return [];
    return this.select_list_el.map((el, item_index) => {
      let option_index = this.values.indexOf(values[item_index]);
      if (option_index == -1) {
        el.val('null').addClass('is_null');
        return null;
      }
      el.val(option_index).removeClass('is_null');
      return values[item_index];
    });
  }
  valid() {
    if (!super.valid()) return false;
    if (!this._required_check()) return false;
    return true;
  }
  change() {
    this.value = this._get_el_val();
    this.trigger_change();
    let checked_count = this.value.filter(val => val != null).length;
    let item_count = this.select_list_el.length;
    if (checked_count == item_count) this.valid();
  }
  set_value(new_value) {
    new_value = this._set_el_val(new_value);
    super.set_value(new_value);
  }
  _required_check() {
    if (!this.required) return true;
    if (this.value.length != 0 && this.value.findIndex(v => v == null) == -1) return true;
    this.el.attr('error', '必填');
    return false;
  }
}

/* ================ output_button ================ */
class enter_block_output_button extends enter_block {
  constructor(data, parent_area) {
    super(data, parent_area);
    this.set_default_value(data.default);
  }
  toggle_view(target_val) {
    super.toggle_view(target_val);
    this.not_clickable = !!target_val || !!this.disabled;
    this.output_el.attr('disabled', this.not_clickable || null);
  }
  getable() { return true; }
  data_set(data) {
    if (data.custom_type) this.custom_type = data.custom_type;
    if (data.required) this.required = true;
    if (data.disabled) this.disabled = true;
  }
  generate_el(data) {
    if (data.label) {
      $('<label>').text(data.label).toggleClass('required', data.required || false).appendTo(this.el);
    }
    this.output_el = $('<output>')
      .attr('disabled', data.disabled || null)
      .on('click', () => {
        if (this.not_clickable) return;
        this.trigger_click();
      });
    if (data.placeholder) this.output_el.attr('placeholder', data.placeholder);
    let el = enter_block_icon_outer(this.output_el, data.icon);
    square_style(el, data).appendTo(this.el);
    if (data.tail_label) {
      $('<label>').text(data.tail_label).appendTo(this.el);
    }
  }
  set_default_value(default_value) {
    this.value = default_value || null;
  }
  set_onclick(click_function) {
    this.click_function = click_function;
  }
  set_value(new_value) {
    this.output_el.val(new_value || '');
    super.set_value(new_value || '');
  }
  valid() {
    if (!super.valid()) return false;
    if (!this._required_check()) return false;
    return true;
  }
  _required_check() {
    if (!this.required || this.value) return true;
    this.el.attr('error', '必填');
    return false;
  }
}

/* ================ 通用處理 ================ */
function radio_can_be_canceled(el) {
  let target_arr = [];
  if(/input/i.test(el.tagName) && el.type == 'radio') target_arr.push(el);
  else {
    el.querySelectorAll('input[type="radio"]').forEach(el => target_arr.push(el));
  }
  target_arr.forEach(radio_el => {
    radio_el.addEventListener('mousedown', () => {
      if(!radio_el.checked) return;
      radio_el.checked = false;
      let disabled_click = e => {
        e.preventDefault();
        radio_el.removeEventListener('click', disabled_click);
        setTimeout(() => {
          radio_el.dispatchEvent(new Event('change'));
        }, 100);
      };
      radio_el.addEventListener('click', disabled_click);
    });
  });
}
function generate_enter_block(block_data, parent_area) {
  switch (block_data.type) {
    case 'main': {
      if(block_data.all_check) parent_area.check_function = block_data.all_check;
      if(block_data.all_change) parent_area.change_function = block_data.all_change;
      break;
    }
    case 'outer': return new enter_block_outer(block_data, parent_area);
    case 'section_title': return new enter_block_section_title(block_data, parent_area);
    case 'br': return new enter_block(block_data, parent_area);
    case 'hr': return new enter_block_hr(block_data, parent_area);
    case 'span': return new enter_block_span(block_data, parent_area);
    case 'label': return new enter_block_label(block_data, parent_area);

    case 'output': return new enter_block_output(block_data, parent_area);

    case 'textarea': return new enter_block_textarea(block_data, parent_area);
    case 'input_onoff': return new enter_block_input_onoff_checkbox(block_data, parent_area);
    case 'onoff': return new enter_block_onoff(block_data, parent_area);
    case 'radio': return new enter_block_radio(block_data, parent_area);
    case 'checkbox': return new enter_block_checkbox(block_data, parent_area);
    case 'radio_table': return new enter_block_radio_table(block_data, parent_area);
    case 'select_table': return new enter_block_select_table(block_data, parent_area);

    case 'password': return new enter_block_password(block_data, parent_area);

    case 'input': return new enter_block_input(block_data, parent_area);
    case 'number': return new enter_block_number(block_data, parent_area);
    case 'select': return new enter_block_select(block_data, parent_area);
    case 'output_button': return new enter_block_output_button(block_data, parent_area);
    default: return new enter_block(block_data, parent_area);
  }
}
function enter_block_icon_outer(el, icon) {
  if (!icon) return el;
  let outer = $('<div class="icon_input"></div>').append(el);
  let icon_el;
  switch (icon.replace(/^r_/, '')) {
    case 'start': icon_el = $('<span>始</span>'); break;
    case 'end': icon_el = $('<span>終</span>'); break;
    case 'date': icon_el = $('<span><img src="/images/icon_date.svg"></span>'); break;
  }
  if (/^r_/.test(icon)) outer.append(icon_el);
  else outer.prepend(icon_el);
  return outer;
}
function square_style(el, data) {
  let style = {};
  if (data.square_width) style['--width'] = data.square_width;
  if (data.square_height) style.height = data.square_height;
  return el.css(style);
}
function options_list_style(el, list_style) {
  if (!list_style) return;
  let available = ['nowrap', 'column'];
  if (available.indexOf(list_style) != -1) {
    el.addClass(list_style);
    return;
  }
  if (!Array.isArray(list_style)) return;
  list_style.forEach(type => {
    if (available.indexOf(type) != -1) {
      el.addClass(type);
    }
  });
}